module.exports = __webpack_public_path__ + "static/img/banner1.30f7df3.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/ShopSelfPrinting/banner1.png
// module id = oqXD
// module chunks = 10